<div class="message">
    Your subscription has expired.<br/>
    Please contact your NetSuite administrator
</div>
    
<div class = "re-login"> 
    If you already have already renewed subscription,
    <span class="click-here">click here</span> to re-login
</div>